import { Notification, NotificationProps, Typo } from '@wrisk/ui-components'
import React, { FunctionComponent } from 'react'

import { getPolicyVersion, PolicyVersion } from '../../../domain'
import { usePromotion } from '../../../hooks/covers'
import { TKey, useWriskTranslation } from '../../../infrastructure/internationalisation'
import { usePolicy } from '../../product/policy/PolicyProvider'

interface PromoRemovedBannerProps extends NotificationProps {
  updatedPolicyVersion: PolicyVersion
}

const tKey = TKey('components.promotion-removed-banner')

export const PromotionRemovedBanner: FunctionComponent<PromoRemovedBannerProps> = ({
  updatedPolicyVersion,
  ...props
}) => {
  const { t } = useWriskTranslation()

  const { policy } = usePolicy()

  const { quote: currentQuote } = getPolicyVersion(policy)
  const { quote: updatedQuote } = updatedPolicyVersion

  const currentPromotion = usePromotion(currentQuote)
  const updatedPromotion = usePromotion(updatedQuote)

  return currentQuote.promoCode && !updatedPromotion && currentPromotion ? (
    <Notification type='standalone' variant='warning' {...props}>
      <Typo>{t(tKey(currentQuote.promoCode, 'header'))}</Typo>
    </Notification>
  ) : null
}
